export enum MandatorParameterKeys {
  // DeinKinoTicket
  MP_DEINKINOTICKET_URL = 'MP_DEINKINOTICKET_URL',
  MP_DEINKINOTICKET = 'MP_DEINKINOTICKET',
  
  // Cinetixx-Abrechnung
  MP_ASP_WERBEKOSTEN = 'MP_ASP_WERBEKOSTEN',
  MP_ASP_ONLINE_FEE = 'MP_ASP_ONLINE_FEE',
  
  // Online
  MP_ONLINE_PAY_CINETIXX_FEE = 'MP_ONLINE_PAY_CINETIXX_FEE',
  MP_KINOHELD = 'MP_KINOHELD',
  MP_CINEPROG = 'MP_CINEPROG',
  MP_BOOKING_CXDE = 'MP_BOOKING_CXDE',

  // Numero
  MP_NUMERO = 'MP_NUMERO',
  MP_NUMERO_FUTURE = 'MP_NUMERO_FUTURE',
  
  // Web Manager
  WEB_NEW_REPORTER = 'WEB_NEW_REPORTER',
  MP_SETTLE_BY_CINEMA = 'MP_SETTLE_BY_CINEMA',
  LYNCK_CONTRACT_START_DATE = 'LYNCK_CONTRACT_START_DATE',

  // Web-Cash
  WEBCASH_ACCESS = 'WEBCASH_ACCESS',
  
  // API
  MP_API_TOKEN = 'MP_API-TOKEN',
  
  // Stadtgutscheine (zmyle)
  MP_ZMYLE_API = 'MP_ZMYLE_API',
  
  // Acardo
  MP_ACARDO_TOKEN = 'MP_ACARDO-TOKEN'
}

